import axios from 'axios'
import { makeQueryString } from '@/utils/Query.js'
const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: API_BASE_URL + "/homepage/inquiry/"
};

const inquiryAPIDFN = {
    inquiryAPI: (APIName, conditions, paths) => {
        return inquiryAPI[APIName](conditions, paths);
    }
};

const inquiryAPI = {
    API_BASE_URL: `${API_BASE_URL}`,
    insertInquiry: (conditions, paths) => {
        const uri = paths || "inquiry/insertInquiry"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
};

export { inquiryAPIDFN, inquiryAPI };
